import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Http, Response } from '@angular/http';

import { BaseWebService } from "../../../shared/services/base-web.service";
import 'rxjs/add/observable/throw';

@Injectable()
export class CommunicationMenuService {
    constructor(private _http: Http,
        private _basewebservice: BaseWebService,
        ) { }

     // check if vc enabled
    getUserStatus() {
        return this._basewebservice.request("v1/va/user_status/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * error.
     * @param  {Response|any} error error response.
     */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }
}